/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_VENDOR = `${url}/LOAD_VENDOR`;
export const LOAD_VENDOR_SUCCESS = `${url}/LOAD_VENDOR_SUCCESS`;
export const LOAD_VENDOR_ERROR = `${url}/LOAD_VENDOR_ERROR`;

export const CREATE_VENDOR = `${url}/CREATE_VENDOR`;
export const CREATE_VENDOR_SUCCESS = `${url}/CREATE_VENDOR_SUCCESS`;
export const CREATE_VENDOR_ERROR = `${url}/CREATE_VENDOR_ERROR`;

export const UPDATE_VENDOR = `${url}/UPDATE_VENDOR`;
export const UPDATE_VENDOR_SUCCESS = `${url}/UPDATE_VENDOR_SUCCESS`;
export const UPDATE_VENDOR_ERROR = `${url}/UPDATE_VENDOR_ERROR`;

export const DELETE_VENDOR = `${url}/DELETE_VENDOR`;
export const DELETE_VENDOR_SUCCESS = `${url}/DELETE_VENDOR_SUCCESS`;
export const DELETE_VENDOR_ERROR = `${url}/DELETE_VENDOR_ERROR`;

export const LOAD_VENDOR_RECORDS_META_DATA = `${url}/LOAD_VENDOR_RECORDS_META_DATA`;
export const LOAD_VENDOR_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_VENDOR_RECORDS_META_DATA_SUCCESS`;
export const LOAD_VENDOR_RECORDS_META_DATA_ERROR = `${url}/LOAD_VENDOR_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_VENDOR_COLLECT = `${url}/LOAD_VENDOR_COLLECT`;
export const LOAD_VENDOR_COLLECT_SUCCESS = `${url}/LOAD_VENDOR_COLLECT_SUCCESS`;
export const LOAD_VENDOR_COLLECT_ERROR = `${url}/LOAD_VENDOR_COLLECT_ERROR`;

export const LOAD_VENDOR_PAY = `${url}/LOAD_VENDOR_PAY`;
export const LOAD_VENDOR_PAY_SUCCESS = `${url}/LOAD_VENDOR_PAY_SUCCESS`;
export const LOAD_VENDOR_PAY_ERROR = `${url}/LOAD_VENDOR_PAY_ERROR`;
export const LOAD_VENDOR_TRANSACTION = `${url}/LOAD_VENDOR_TRANSACTION`;
export const LOAD_VENDOR_TRANSACTION_SUCCESS = `${url}/LOAD_VENDOR_TRANSACTION_SUCCESS`;
export const LOAD_VENDOR_TRANSACTION_ERROR = `${url}/LOAD_VENDOR_TRANSACTION_ERROR`;

//category
export const LOAD_VENDOR_CATEGORY = `${url}/LOAD_VENDOR_CATEGORY`;
export const LOAD_VENDOR_CATEGORY_SUCCESS = `${url}/LOAD_VENDOR_CATEGORY_SUCCESS`;
export const LOAD_VENDOR_CATEGORY_ERROR = `${url}/LOAD_VENDOR_CATEGORY_ERROR`;

export const CREATE_VENDOR_CATEGORY = `${url}/CREATE_VENDOR_CATEGORY`;
export const CREATE_VENDOR_CATEGORY_SUCCESS = `${url}/CREATE_VENDOR_CATEGORY_SUCCESS`;
export const CREATE_VENDOR_CATEGORY_ERROR = `${url}/CREATE_VENDOR_CATEGORY_ERROR`;

const constants = {
  LOAD_VENDOR,
  LOAD_VENDOR_SUCCESS,
  LOAD_VENDOR_ERROR,

  LOAD_VENDOR_CATEGORY,
  LOAD_VENDOR_CATEGORY_SUCCESS,
  LOAD_VENDOR_CATEGORY_ERROR,

  CREATE_VENDOR_CATEGORY,
  CREATE_VENDOR_CATEGORY_SUCCESS,
  CREATE_VENDOR_CATEGORY_ERROR,

  LOAD_VENDOR_COLLECT,
  LOAD_VENDOR_COLLECT_SUCCESS,
  LOAD_VENDOR_COLLECT_ERROR,

  LOAD_VENDOR_PAY,
  LOAD_VENDOR_PAY_SUCCESS,
  LOAD_VENDOR_PAY_ERROR,

  LOAD_VENDOR_TRANSACTION,
  LOAD_VENDOR_TRANSACTION_SUCCESS,
  LOAD_VENDOR_TRANSACTION_ERROR,

  CREATE_VENDOR,
  CREATE_VENDOR_SUCCESS,
  CREATE_VENDOR_ERROR,

  UPDATE_VENDOR,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_ERROR,

  DELETE_VENDOR,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_VENDOR_RECORDS_META_DATA,
  LOAD_VENDOR_RECORDS_META_DATA_SUCCESS,
  LOAD_VENDOR_RECORDS_META_DATA_ERROR,
};

export default constants;
